import Heading from "../../../components/Heading";
import Card from "../../../components/Card";
import React, {useMemo} from "react";
import {StoredSpot} from "../../../types/Individualization";
import Icon from "../../../components/Icon";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {v4 as uuid} from "uuid"
import TextElementInput from "../TextElementInput";
import ImgElementInput from "../ImgElementInput";
import {useTranslation} from "react-i18next";
import cx from "classnames";
import styles from "./../CustomizerPopup.module.css";
import {useCustomizer} from "../../../contexts/CustomizerContext";

type CuttingMaskElementInputProps = {
    spot: StoredSpot;
}

const CuttingMaskElementInput: React.FC<CuttingMaskElementInputProps> = (
    {
        spot,
    }
) => {
    const { t } = useTranslation(['customizer'])
    const {
        cuttingMaskElements,
        setCuttingMaskElements
    } = useCustomizer()

    const imageMaxReached = useMemo(() => {
        const elements = cuttingMaskElements.get(spot.id) ?? []
        return spot.max_image_fields <= elements.filter((ele) => ele.type === 'image').length
    }, [cuttingMaskElements, spot])

    const textMaxReached = useMemo(() => {
        const elements = cuttingMaskElements.get(spot.id) ?? []
        return spot.max_text_fields <= elements.filter((ele) => ele.type === 'text').length
    }, [cuttingMaskElements, spot])

    const addElement = (type: 'text' | 'image') => {
        if (
            (!textMaxReached && type === 'text') ||
            (!imageMaxReached && type === 'image')
        ) {
            setCuttingMaskElements(prev => {
                const old = prev.get(spot.id) ?? []
                return new Map(prev.set(spot.id, [...old, {uid: uuid(), type}]))
            })
        }
    }

    const removeElement = (uid: string) => {
        setCuttingMaskElements(prev => {
            const old = prev.get(spot.id) ?? []
            return new Map(prev.set(spot.id, old.filter((e) => e.uid !== uid)))
        })
    }

    return (
        <Card key={spot.id}>
            <>
                <Heading level={4}>{spot.name}</Heading>
                <div style={{gap: '1rem'}} className="d-flex flex-row">
                    {spot.max_image_fields !== 0 && (
                        <span>
                        {t('max_image_elements', {number: spot.max_image_fields ?? t('unlimited')})}
                    </span>
                                )}
                    {spot.max_text_fields !== 0 && (
                                    <span>
                        {t('max_text_elements', {number: spot.max_text_fields ?? t('unlimited')})}
                    </span>
                    )}
                </div>
                <div style={{gap: '1rem'}} className={'my-5 d-flex flex-row'}>
                    {!textMaxReached && (
                        <Card onClick={() => addElement('text')}>
                            <div className={cx(styles['cutting-card-element'])}>
                                <Icon icon={faPlus} size={'4x'}/>
                                {t('add_text_element')}
                            </div>
                        </Card>
                    )}
                    {!imageMaxReached && (
                        <Card onClick={() => addElement('image')}>
                            <div className={cx(styles['cutting-card-element'])}>
                                <Icon icon={faPlus} size={'4x'}/>
                                {t('add_image_element')}
                            </div>
                        </Card>
                    )}
                </div>
                <div className={'d-flex flex-column'} style={{gap: '1rem'}}>
                    {cuttingMaskElements.get(spot.id)?.map((ele) => {
                        return (ele.type === 'text')
                            ? (<TextElementInput
                                key={ele.uid}
                                spot={spot}
                                uid={ele.uid}
                                onDelete={removeElement}
                            />)
                            : (<ImgElementInput
                                key={ele.uid}
                                spot={spot}
                                uid={ele.uid}
                                onDelete={removeElement}
                                toggleMediaOverview={() => {
                                }}
                            />)
                    })}
                </div>
            </>
        </Card>
    )
}

export default CuttingMaskElementInput
